module.exports = __webpack_public_path__ + "static/media/quoteBorderSml.1eef4b34.svg";